import {
    Component,
    Input,
    OnChanges,
    SimpleChanges,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { InputComponent } from "@components/input/input.component";
import { take } from "rxjs/operators";
import { ModalSettings } from "~app/common/components/modal/modal-models";
import { RaskModalService } from "~app/common/components/modal/rask-modal.service";
import { ConfirmDialogResponse } from "~app/common/models/constants";
import { IGetArbetsorderRequest } from "~app/features/planera/model/IGetArbetsorderRequest";
import { ArbetsorderSearchMinaFilterService } from "../../arbetsorder-search-mina-filter.service";
import { ArbetsorderSearchTexts } from "../../models/arbetsorder-search-texts";
import { INamedSokfilter } from "../../models/named-sokfilter";

@Component({
    selector: "rask-arbetsorder-spara-sokfilter",
    templateUrl: "./arbetsorder-spara-sokfilter.component.html",
    styleUrls: ["./arbetsorder-spara-sokfilter.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        InputComponent,
        FormsModule,
        ButtonComponent
    ]
})
export class ArbetsorderSparaSokfilterComponent implements OnChanges {
    errors: string[];
    model: INamedSokfilter = { namn: "" } as INamedSokfilter;
    show = false;
    @Input() sokfilter: IGetArbetsorderRequest;
    texts = ArbetsorderSearchTexts.texts;

    private readonly minaFilterService = inject(ArbetsorderSearchMinaFilterService);
    private readonly modalService = inject(RaskModalService);

    abort() {
        this.close();
    }

    close() {
        this.errors = [];
        this.show = false;
        this.reset();
    }

    ngOnChanges(changesObj: SimpleChanges): void {
        if (changesObj.sokfilter !== undefined && changesObj.sokfilter.currentValue) {
            this.model = Object.assign(this.model, changesObj.sokfilter.currentValue) as INamedSokfilter;
            this.show = true;
        }
    }

    trySave() {
        if (!this.model.namn) {
            this.errors = [this.texts.angeNamn];
            return;
        }
        if (!this.minaFilterService.nameIsUnique(this.model)) {
            const ejUniktNamn = this.model.namn;
            this.modalService.confirm(new ModalSettings(this.texts.detFinnsRedanEnSokning, `${this.texts.villDuSkrivaOver}"${ejUniktNamn}"?`))
                .pipe(take(1))
                .subscribe((ok: string) => {
                    if (ok === ConfirmDialogResponse.cancel) {
                        return;
                    }
                    this.minaFilterService.updateSearchFilterByNamn(this.model);
                    this.close();
                });
        } else {
            if (this.minaFilterService.saveLimitReached()) {
                this.errors = [this.texts.garEjAttSparaFlerSokningar];
                return;
            }
            this.minaFilterService.saveSearchFilter(this.model);
            this.close();
        }
    }

    private reset() {
        this.model = { namn: "" } as INamedSokfilter;
    }
}
